module.exports = __webpack_public_path__ + "img/page-under-construction.0f49abca.svg";